// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".FormLabel[data-v-1ce5d31f]{display:inline-flex;align-items:center;line-height:1.25}.FormLabel .badge[data-v-1ce5d31f]{position:static}.FormLabel .fa-lg[data-v-1ce5d31f]{margin-top:-2px}\n", ""]);
// Exports
module.exports = exports;
